import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import SystemUpdateAlt from "@mui/icons-material/SystemUpdateAlt";
import CloudOff from "@mui/icons-material/CloudOff";

const VersionBadgeAndReload = ({
  shouldRefresh,
  isReloading,
  clearCacheAndReload,
}) => {
  return (
    <Tooltip
      title={
        !navigator.onLine
          ? "Offline"
          : shouldRefresh
          ? "Update to latest version"
          : "Reload cache and refresh"
      }
    >
      <span>
        <IconButton
          aria-label="Reload application"
          onClick={clearCacheAndReload}
          disabled={isReloading || !navigator.onLine}
          size="small"
        >
          {navigator.onLine ? (
            <SystemUpdateAlt fontSize="small" />
          ) : (
            <CloudOff fontSize="small" />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default VersionBadgeAndReload;
export { VersionBadgeAndReload };
